export enum EHeightMeasurementUnit {
	METER = "m",
	CENTIMETER = "cm",
	FOOT = "ft",
}
